<script>
    import { onMount } from "svelte";
    import { AlertaService } from "../../../../Controller/Componentes/Aviso/tableNotifi";
    import { user } from "../../../../stores/user";
    import Buttons from "../../../system/components/buttons/buttons.svelte";
    import Modal from "./../../../system/components/modals/modal.svelte";
    import {
        panelController,
        enviarNotificacion,
    } from "../../../../stores/service";


    let modal;

    let viewtable = {
        status: false,
    };

    let datainfo;

    let activityNotf = new AlertaService(
        JSON.parse(JSON.stringify($panelController.service.tableadmins)),
        JSON.parse(JSON.stringify($user.email)),
    );
    let cloudMessaging = [];

    async function deleteDevice(index) {

        
        //Eliminar registro

        modal.Setinfo({
            title: "Eliminar dispostivo.",
            body: `¿Desea eliminar el dispositivo ${cloudMessaging[datainfo[index].indexDevices].model}?`,
        });

        let mod = await modal.activeModal();
        if (mod) {
            activityNotf.deleteRecord(index);
            inicVista();
        }
    }

    export function DesactivarView(){
        viewtable.status = false;
       
    }


   export function inicVista() {
        cloudMessaging = activityNotf.listAllDevices();
        datainfo = activityNotf.listdata;
        viewtable.status = true;
    }

function statusNot() {
    activityNotf.act(activityNotf.documentUser);
    
}




    onMount(async () => {

        inicVista()
    });
</script>

{#if viewtable.status}
    {#if cloudMessaging && cloudMessaging.length > 0}
        <ul class="devices">
            {#each cloudMessaging as device, index}
                <li class="device">
                    <div class="device-main">
                        <div class="device-model">{device.model}</div>
                        <div class="device-meta">
                            {activityNotf.listdata[index].name} · {device.platform}
                        </div>
                    </div>
                    <div class="custom-control custom-switch device-switch">
                        <input
                            class="custom-control-input"
                            type="checkbox"
                            role="switch"
                            id="device-switch-{index}"
                            aria-label="Notificaciones de {device.model}"
                            bind:checked={cloudMessaging[index].active}
                            on:change={() => statusNot(index)}
                        />
                        <label
                            class="custom-control-label"
                            for="device-switch-{index}"
                        ></label>
                    </div>
                    <Buttons
                        model="tDelete"
                        on:activated={() => deleteDevice(index)}
                    />
                </li>
            {/each}
        </ul>
    {:else}
        <p class="empty">
            Sin dispositivos. Agrega uno para recibir avisos.
        </p>
    {/if}
{/if}

<Modal bind:this={modal} />

<style>
    .devices {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .device {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.5rem 0;
        border-top: 1px solid rgba(44, 51, 32, 0.1);
    }

    .device-main {
        flex: 1;
        min-width: 0;
    }

    .device-model {
        font-weight: 600;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .device-meta {
        font-size: 0.75rem;
        color: #83805f;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .device-switch {
        flex: none;
    }

    .empty {
        margin: 0.25rem 0 0;
        font-size: 0.85rem;
        color: #83805f;
    }
</style>
